import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { Modal, Box, CircularProgress } from "@mui/material"
import { useApiService } from "../../hooks/Api/useApiService"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"
import WisdomDrop from "../../AI/WisdomDrop"
import T from "../../hooks/Language/T"
import ReflectionModal from "../ReflectionModal/ReflectionModal"

const WisdomModal = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false)
  const [wisdom, setWisdom] = useState(null)
  const { getData } = useApiService()
  const reflectionRef = useRef()

  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  useEffect(() => {
    if (open && !wisdom) {
      const fetchWisdom = async () => {
        try {
          const data = await getData("ai/wisdom")
          setWisdom(data?.wisdom)
        } catch (error) {
          console.error(error.message)
        }
      }
      fetchWisdom()
    }
  }, [open, wisdom])

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const openReflectModal = () => {
    if (reflectionRef.current) {
      reflectionRef.current.childFunction()
    }
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <T>
        <ReflectionModal ref={reflectionRef} wisdom={wisdom} />
        <ModalCloseButton handleClose={handleClose} />
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "background.paper",
            borderRadius: "0.8rem",
            boxShadow: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {wisdom ? (
            <WisdomDrop
              quote={wisdom?.quote}
              question={wisdom?.question}
              onReflect={openReflectModal}
            />
          ) : (
            <CircularProgress />
          )}
        </Box>
      </T>
    </Modal>
  )
})

export default WisdomModal
